import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from '../../../../shared/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../previewfile/previewfile.component';

@Component({
  selector: 'app-usernmanual',
  templateUrl: './usernmanual.component.html',
  styleUrls: ['./usernmanual.component.css']
})
export class UsernmanualComponent implements OnInit {
  pdfForm: FormGroup;
  filePath: string = '';
  fileName: string = '';
  userType: string | null = null;

  private manualFileMap = {
    MSME: {
      path: 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-MSME.pdf'
    },
    IA: {
      path: 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf',
      name: 'RAMP-Portal-UserManul-For-V1-IA.pdf'
    }
  };

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog
  ) {
    this.pdfForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.userType = sessionStorage.getItem('UserType')?.toUpperCase() || null;
  }

  viewManual(manualType: 'MSME' | 'IA') {
    const manual = this.manualFileMap[manualType];
    if (manual) {
      this.filePath = manual.path;
      this.fileName = manual.name;

      this.apiService.getFilePreview(this.filePath).subscribe({
        next: (fileUrl) => {
          this.dialog.open(PreviewfileComponent, {
            width: '1200px',
            height: '80%',
            data: { fileUrl, fileName: this.fileName }
          });
        }
      });
    }
  }
}

